module.exports = __webpack_public_path__ + "media/src/images/testimonials/flowsofly-0abb98b820d718ae4ddb112f594a6e84.jpg";